export class Kyc {
    id?: string;
    name?: string;
    status: string;
    note?: string;
    ktpNumber?: string;
    ktpPhotoUri?: string;
    ktpSelfieUri?: string;
    program?: string;
    programUserChoice?: string;

    constructor(data: any = {}) {
        this.id = data.id;
        this.name = data.name;
        this.status = data.status || 'NOT_SAVED';
        this.note = data.note;
        this.ktpNumber = data.ktpNumber;
        this.ktpPhotoUri = data.ktpPhotoUri;
        this.ktpSelfieUri = data.ktpSelfieUri;
        this.program = data.program;
        this.programUserChoice = data.programUserChoice;
    }

    static build(data: any): Kyc {
        return new Kyc(data);
    }

    toJSON() {
        return {
            status: this.status,
            name: this.name,
            note: this.note,
            ktpNumber: this.ktpNumber,
            ktpPhotoUri: this.ktpPhotoUri,
            ktpSelfieUri: this.ktpSelfieUri,
            program: this.program,
            programUserChoice: this.programUserChoice,
        };
    }
}
